import { useState, useEffect } from "react";
import { API_URL } from "../../api-config";
import AgentsDashboard from "../agents/dashboard";
import axios from "axios";


const AdminPanel = () => {
    const [token, setToken] = useState(localStorage.getItem("token"));


    const [view, setView] = useState(false);

    useEffect(() => {
        axios.get(`${API_URL}/users-api/me`, {
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + token,
            },
        }).then((response) => {
            localStorage.setItem("token", token);
            console.log(response.data);
            setToken(token);
            let userType = response.data.roles;
            console.log(userType);
            if (userType.includes("Admin")) {
                setView(true);
            } else {
                // window.location.href = '/';
            }
        });
    }, [token]);

 

    return (
        <div className='w-full h-full text-white p-5 flex flex-row justify-center'>
            {view && 
                <AgentsDashboard />
            }
        </div>
    );
};

export default AdminPanel;
